import { createAction } from '@reduxjs/toolkit';

export const setFromOAuth = createAction('oauth/SET_FROM_OAUTH');
